export const u2RootPath = 'http://passport.xdf.cn/'
export const appId = 32



// WEBPACK FOOTER //
// ./src/api/js/home/staticdata.js